// Configuration for all sub-landing pages.
// Each entry drives the generic SubLanding page renderer.

export const PROFILE_OPTIONS = [
  { label: "Ik heb een eigen paard", href: "/eigen-paard", color: "var(--forest)" },
  { label: "Ik rijd op een manege", href: "/manege-ruiter", color: "var(--sand)" },
  { label: "Ik ben trainer", href: "/trainer", color: "var(--sand-dark)" },
  { label: "Ik ben professional", href: "/professional", color: "var(--forest)" },
  { label: "Ik beheer een stal of manege", href: "/manege-module", color: "var(--ink)" },
  { label: "Ik ben fokker", href: "/fokkerij", color: "var(--sand-dark)" },
];

export const PROMISES = [
  {
    label: "Mijn Paard",
    title: "Gezondheid, afspraken, dossier en historie.",
    description:
      "Elk paard krijgt zijn eigen tijdlijn met medisch dossier, planning en foto's.",
  },
  {
    label: "Mijn Groei",
    title: "Training, wedstrijdanalyse en EquiCoach inzichten.",
    description:
      "Word beter met data. Doelen, protocollen en de Equestrian Performance Index.",
  },
  {
    label: "Mijn Team",
    title: "Samenwerken met trainer, hoefsmid, tandarts, fysio en eigenaar.",
    description:
      "Iedereen rond het paard in één dossier — met de juiste rechten per persoon.",
  },
];

export const MODULES = [
  { label: "Noodnummers", href: "/noodnummerpaard" },
  { label: "Fokkerij", href: "/fokkerij" },
  { label: "Hoefsmid", href: "/hoefsmid" },
  { label: "Tandarts", href: "/paardentandarts" },
  { label: "Fysio / Osteo", href: "/fysio-osteo" },
  { label: "Trainer", href: "/trainer" },
  { label: "Manege", href: "/manege-module" },
  { label: "Wedstrijdanalyse", href: "/wedstrijdanalyse" },
  { label: "Premium", href: "/premium" },
];

export const NAV_GROUPS = [
  { label: "Voor eigenaren", href: "/eigen-paard" },
  { label: "Voor manege ruiters", href: "/manege-ruiter" },
  { label: "Voor trainers", href: "/trainer" },
  { label: "Voor professionals", href: "/professional" },
];

export const LANDINGS = {
  "eigen-paard": {
    slug: "eigen-paard",
    eyebrow: "Voor paardeneigenaren",
    title: "Alles voor jouw paard. In één app.",
    subtitle:
      "Beheer gezondheid, training, planning en professionals vanuit één overzichtelijk dossier.",
    primaryCTA: { label: "Start gratis", href: "/#waitlist" },
    secondaryCTA: { label: "Bekijk Premium", href: "/premium" },
    heroScreenshot: {
      url: "/assets/owner-horse.png",
      alt: "Paardprofiel — gewicht, vaccinatie, EquiCoach, voeding en training in één scherm",
      caption: "Jouw paard, compleet in beeld.",
    },
    problem:
      "Je houdt afspraken, foto's, training, voeding en gezondheid nu waarschijnlijk verspreid bij — in WhatsApp-groepen, schoenendozen en losse apps. Daardoor mis je overzicht.",
    solution:
      "EquiSight maakt van jouw paard één compleet digitaal dossier dat met je meereist.",
    benefits: [
      "Eén compleet paardenprofiel per paard",
      "Gezondheid, hoefsmid, tandarts en fysio op één plek",
      "Agenda met slimme herinneringen",
      "Foto's, notities en historie zonder limiet",
      "Backup van al je data bij Premium",
    ],
    pricing: {
      tiers: [
        { name: "Basic", price: "€0", note: "1 paard · altijd gratis" },
        { name: "Premium", price: "€4,99", note: "Meerdere paarden + backup", highlight: true },
      ],
    },
    finalCTA: { eyebrow: "Klaar voor de start?", title: "Begin vandaag met jouw eerste paard.", href: "/#waitlist" },
  },

  premium: {
    slug: "premium",
    eyebrow: "Premium",
    title: "Meer paarden. Meer overzicht. Meer zekerheid.",
    subtitle:
      "Upgrade naar Premium en beheer al je paarden zonder beperkingen — met volledige EquiCoach intelligence.",
    primaryCTA: { label: "Start 14 dagen gratis", href: "/#waitlist" },
    secondaryCTA: { label: "Alle prijzen", href: "/#pricing" },
    audience:
      "Voor eigenaren, sportruiters en paardenhouders met meerdere paarden.",
    features: [
      "Onbeperkt paarden toevoegen",
      "Volledige historie per paard",
      "Data backup",
      "Uitgebreide EquiCoach inzichten",
      "Slimme meldingen en planning",
      "Gezondheid en training compleet gekoppeld",
    ],
    pricing: {
      tiers: [
        { name: "Premium", price: "€4,99", note: "Minder dan €0,17 per dag", highlight: true },
      ],
    },
    finalCTA: { eyebrow: "Klaar?", title: "Upgrade naar Premium.", href: "/#waitlist" },
  },

  "manege-ruiter": {
    slug: "manege-ruiter",
    eyebrow: "Voor manege ruiters",
    title: "Beter worden, ook zonder eigen paard.",
    subtitle:
      "Volg je lessen, trainingen en ontwikkeling binnen EquiSight — voor minder dan een kop koffie per maand voor papa of mama. Of een lekkere ijsco met slagroom.",
    primaryCTA: { label: "Start met Premium", href: "/#waitlist" },
    secondaryCTA: { label: "Hoe werkt het?", href: "#features" },
    problem:
      "Als manege ruiter heb je vaak geen eigen paard, maar je wilt wél groeien en overzicht houden over je lessen, doelen en de paarden waar je op rijdt.",
    solution:
      "Manege functionaliteit zit standaard in Premium — volg jouw eigen ontwikkeling en bekijk de gekoppelde manegepaarden read-only.",
    features: [
      "Trainingen bijhouden",
      "Doelen stellen",
      "Progressie volgen",
      "Manegepaarden bekijken met naam en foto",
      "Geen toegang tot privégezondheidsdata",
    ],
    pricing: {
      tiers: [
        { name: "Premium", price: "€4,99", note: "Per maand · manege functionaliteit inbegrepen", highlight: true },
      ],
    },
    finalCTA: { eyebrow: "Word lid", title: "Start als manege ruiter.", href: "/#waitlist" },
  },

  "manege-module": {
    slug: "manege-module",
    eyebrow: "Voor maneges & stallen",
    title: "Maak jouw manege digitaal toegankelijk voor iedere ruiter.",
    subtitle:
      "Geef ruiters binding met paarden, lessen en voortgang — zonder gevoelige staldata te delen.",
    primaryCTA: { label: "Vraag toegang aan", href: "/#waitlist" },
    secondaryCTA: { label: "Bekijk modules", href: "#features" },
    audience:
      "EquiSight helpt maneges en stallen om ruiters langer betrokken te houden en zich digitaal te onderscheiden.",
    features: [
      "Manegepaarden zichtbaar maken voor ruiters",
      "Naam en foto per paard",
      "Ruiters koppelen aan paarden",
      "Alleen-lezen toegang voor privacygevoelige data",
      "Les- en trainingshistorie centraal",
      "Gebruikersbeheer met rollen",
    ],
    benefits: [
      "Meer binding met ruiters",
      "Professionelere uitstraling",
      "Extra digitale service voor leden",
      "Nieuwe inkomstenstroom via app-gebruik",
    ],
    pricing: {
      tiers: [
        { name: "Premium", price: "€4,99", note: "Per maand · manege functionaliteit inbegrepen voor ruiters", highlight: true },
      ],
    },
    finalCTA: { eyebrow: "Klaar?", title: "Activeer Manege Module.", href: "/#waitlist" },
  },

  fokkerij: {
    slug: "fokkerij",
    eyebrow: "Fokkerij module",
    title: "Grip op cyclus, dracht en veulenontwikkeling.",
    subtitle:
      "De complete fokkerijmodule voor merriehouders en fokkers — van dekking tot veulen, in één tijdlijn.",
    primaryCTA: { label: "Activeer Fokkerij Module", href: "/#waitlist" },
    secondaryCTA: { label: "Bekijk functies", href: "#features" },
    audience:
      "Voor fokkers, merriehouders en stallen die meerdere merries beheren.",
    features: [
      "Cyclus tracking",
      "Hengstigheid registreren",
      "Inseminatiedata vastleggen",
      "Countdown naar echo's",
      "Drachtcontroles plannen",
      "Stamboom en afstamming",
      "Veulenontwikkeling",
      "Overzicht van alle drachtige merries",
    ],
    pricing: {
      tiers: [
        { name: "Pro", price: "€14,99", note: "Per maand · Fokkerij module inbegrepen in Pro", highlight: true },
      ],
    },
    finalCTA: { eyebrow: "Start vandaag", title: "Start met fokkerijbeheer.", href: "/#waitlist" },
  },

  hoefsmid: {
    slug: "hoefsmid",
    eyebrow: "Hoefsmid module",
    title: "Werk slimmer als hoefsmid. Leg alles professioneel vast.",
    subtitle:
      "Agenda, foto's, opmerkingen en behandelhistorie in één module — minder miscommunicatie, sterker dossier.",
    primaryCTA: { label: "Start als hoefsmid", href: "/#waitlist" },
    secondaryCTA: { label: "Bekijk Professional Bundel", href: "/professional" },
    audience:
      "Voor hoefsmeden die overzicht, bewijsvoering en klantcommunicatie willen verbeteren.",
    features: [
      "Eigen agenda",
      "Afspraken per klant",
      "Paardenprofielen bekijken",
      "Voor- en nafoto's toevoegen",
      "Behandeling noteren",
      "Advies en opmerkingen vastleggen",
      "ETA melding naar klant: \"De hoefsmid is onderweg\"",
    ],
    benefits: [
      "Professioneler werken",
      "Minder miscommunicatie",
      "Betere dossieropbouw",
      "Sterker bij aansprakelijkheid",
    ],
    pricing: {
      tiers: [
        { name: "Professional", price: "€24,99", note: "Per maand · Hoefsmid module inbegrepen in Professional", highlight: true },
      ],
    },
    finalCTA: { eyebrow: "Klaar?", title: "Activeer Hoefsmid Module.", href: "/#waitlist" },
  },

  paardentandarts: {
    slug: "paardentandarts",
    eyebrow: "Tandarts module",
    title: "Een compleet tandheelkundig dossier per paard.",
    subtitle:
      "Registreer bevindingen, behandelingen en opvolging direct in EquiSight.",
    primaryCTA: { label: "Start als paardentandarts", href: "/#waitlist" },
    secondaryCTA: { label: "Bekijk Professional Bundel", href: "/professional" },
    audience:
      "Paardentandartsen, dierenartsen en praktijken die gestructureerd willen werken.",
    features: [
      "Gebitscontrole registreren",
      "Bevindingen per behandeling",
      "Foto's toevoegen",
      "Rapportage aan eigenaar",
      "Opvolgadvies",
      "Historie per paard",
      "Nieuwe afspraak plannen",
    ],
    pricing: {
      tiers: [
        { name: "Professional", price: "€24,99", note: "Per maand · Tandarts module inbegrepen in Professional", highlight: true },
      ],
    },
    finalCTA: { eyebrow: "Klaar?", title: "Activeer Tandarts Module.", href: "/#waitlist" },
  },

  "fysio-osteo": {
    slug: "fysio-osteo",
    eyebrow: "Fysio / Osteo module",
    title: "Volg lichaam, beweging en herstel professioneel op.",
    subtitle:
      "Voor fysiotherapeuten en osteopaten die paarden structureel willen begeleiden.",
    primaryCTA: { label: "Start als fysio/osteo", href: "/#waitlist" },
    secondaryCTA: { label: "Bekijk Professional Bundel", href: "/professional" },
    features: [
      "Intake per paard",
      "Lichaamsbevindingen registreren",
      "Foto's en video's toevoegen",
      "Behandelrapport maken",
      "Oefeningen en opvolging delen",
      "Hersteltraject volgen",
      "Historie per paard",
    ],
    benefits: [
      "Beter inzicht over tijd",
      "Professionele rapportage",
      "Duidelijke communicatie met eigenaar, trainer en ruiter",
    ],
    pricing: {
      tiers: [
        { name: "Professional", price: "€24,99", note: "Per maand · Fysio / Osteo module inbegrepen in Professional", highlight: true },
      ],
    },
    finalCTA: { eyebrow: "Klaar?", title: "Activeer Fysio / Osteo Module.", href: "/#waitlist" },
  },

  trainer: {
    slug: "trainer",
    eyebrow: "Trainer module",
    title: "Coach ruiters met data, doelen en voortgang.",
    subtitle:
      "Maak training meetbaar en begeleiding professioneler — voor één of meerdere ruiters.",
    primaryCTA: { label: "Start als trainer", href: "/#waitlist" },
    secondaryCTA: { label: "Bekijk Pro pakket", href: "/#pricing" },
    audience:
      "Voor instructeurs, trainers en coaches met meerdere ruiters of paarden.",
    features: [
      "Ruiters koppelen",
      "Paarden volgen",
      "Trainingsdoelen instellen",
      "Feedback geven",
      "Wedstrijdresultaten analyseren",
      "Progressie per combinatie bekijken",
      "Protocolanalyses gebruiken voor trainingsfocus",
    ],
    benefits: [
      "Betere begeleiding",
      "Meer structuur",
      "Professionelere communicatie",
      "Meer binding met klanten",
    ],
    pricing: {
      tiers: [
        { name: "Pro", price: "€14,99", note: "Per maand · Trainer module inbegrepen in Pro", highlight: true },
      ],
    },
    finalCTA: { eyebrow: "Klaar?", title: "Activeer Trainer Module.", href: "/#waitlist" },
  },

  wedstrijdanalyse: {
    slug: "wedstrijdanalyse",
    eyebrow: "Wedstrijdanalyse",
    title: "Van protocol naar prestatieverbetering.",
    subtitle:
      "Upload je wedstrijdprotocol en ontdek waar je punten laat liggen — niet alleen je score bekijken, maar begrijpen hoe je beter wordt.",
    primaryCTA: { label: "Analyseer je eerste protocol", href: "/#waitlist" },
    secondaryCTA: { label: "Bekijk Premium", href: "/premium" },
    features: [
      "Protocol foto uploaden",
      "Voor- en achterkant verwerken",
      "Klasse, proefnummer en jurylid herkennen",
      "Scores per onderdeel analyseren",
      "Commentaar samenvatten",
      "Sterke en zwakke punten tonen",
      "Trends per paard-ruiter combinatie",
    ],
    pricing: {
      tiers: [
        { name: "Premium", price: "€4,99", note: "Per maand · wedstrijdanalyse inbegrepen vanaf Premium", highlight: true },
      ],
    },
    finalCTA: { eyebrow: "Klaar?", title: "Start met wedstrijdanalyse.", href: "/#waitlist" },
  },

  professional: {
    slug: "professional",
    eyebrow: "Professional bundel",
    title: "Voor professionals rondom het paard.",
    subtitle:
      "Hoefsmid, tandarts, fysio, osteo of trainer: werk samen in één digitaal paardendossier.",
    primaryCTA: { label: "Start als professional", href: "/#waitlist" },
    secondaryCTA: { label: "Bekijk afzonderlijke modules", href: "#features" },
    audience:
      "De Professional Bundel combineert alle vakmodules in één abonnement.",
    features: [
      "Hoefsmid Module",
      "Tandarts Module",
      "Fysio / Osteo Module",
      "Agenda & klantbeheer",
      "Paardenprofielen & rapportages",
      "Behandelhistorie & dossieropbouw",
      "Communicatie met eigenaar",
    ],
    pricing: {
      tiers: [
        { name: "Professional", price: "€24,99", note: "Per maand · alle vakmodules inbegrepen", highlight: true },
      ],
    },
    finalCTA: { eyebrow: "Klaar?", title: "Kies Professional.", href: "/#waitlist" },
  },

  noodnummerpaard: {
    slug: "noodnummerpaard",
    eyebrow: "Noodnummers paard",
    title: "Altijd de juiste hulp binnen handbereik.",
    subtitle:
      "In een noodgeval telt elke seconde. Met EquiSight heb je alle belangrijke contactgegevens van jouw paard direct paraat — één tik en je belt.",
    primaryCTA: { label: "Zet jouw noodcontacten klaar", href: "/#waitlist" },
    secondaryCTA: { label: "Start gratis met EquiSight", href: "/#waitlist" },
    accent: "danger",
    heroScreenshot: {
      url: "/assets/emergency.png",
      alt: "Noodcontacten — direct bellen, WhatsAppen of navigeren naar dierenarts, kliniek en hoefsmid",
      caption: "Eén tik. Geen paniek zoeken.",
      embeddedFrame: true,
    },
    problem:
      "Je paard heeft iets — koliek, blessure, paniek. En dan begint het zoeken. Wie bel je? Heb je het juiste nummer? Is dit het spoednummer? Kostbare tijd gaat verloren.",
    solution:
      "Met EquiSight heb je alles direct bij de hand. Geen zoeken. Geen twijfel. Eén tik en je hebt contact.",
    scenario: {
      title: "Stel je voor — je paard vertoont koliekverschijnselen.",
      steps: [
        "Je opent EquiSight",
        "Klikt op \"Dierenarts\"",
        "Belt direct",
      ],
      tagline: "Geen stress. Geen zoeken. Alleen actie.",
    },
    features: [
      "Alle noodnummers op één plek",
      "Eén-tik bellen vanuit de app",
      "WhatsAppen met één tik",
      "Direct navigeren naar het adres",
      "Per paard eigen contactlijst",
      "Dierenarts, kliniek, hoefsmid, tandarts, fysio",
      "Adres + routebeschrijving direct beschikbaar",
      "Markeer favoriete nummers met een ster",
      "Spoednummers (112, 144) altijd bovenaan",
    ],
    benefits: [
      "Rust en controle in een noodsituatie",
      "Iedereen op stal heeft dezelfde nummers paraat",
      "Geen vergeten visitekaartjes meer",
      "Reageer seconden sneller bij spoed",
    ],
    audience:
      "Voor paardeneigenaren, verzorgers, trainers en stallen — iedereen die verantwoordelijk is voor een paard.",
    showcase: {
      eyebrow: "Vooraf voor je ingesteld",
      title: "13 categorieën aan contacten — klaar om in te vullen.",
      description:
        "Van dierenarts en spoedkliniek tot zadelmaker, instructeur en weidebeheerder. EquiSight kent jouw wereld en stelt de juiste contactvelden vast voor je klaar. Tik, vul in, klaar.",
      bullets: [
        "Nood & gezondheid — dierenarts, spoed, kliniek, vergiftigingenlijn",
        "Dagelijkse zorg — hoefsmid, tandarts, fysio, instructeur",
        "Stal & weide — stalhouder, weidebeheerder, pensionstal",
        "Voer & materialen — hooi, krachtvoer, stro leveranciers",
      ],
      image: {
        url: "/assets/emergency-manage.png",
        alt: "Noodcontacten beheer-scherm — alle voorgestelde contacten per categorie",
        embeddedFrame: true,
      },
    },
    checklist: {
      title: "Checklist noodnummers paard",
      items: [
        "Dierenarts",
        "Spoedkliniek (24/7)",
        "Dierenambulance · 144",
        "Hoefsmid",
        "Backup contactpersoon",
        "Algemeen alarmnummer · 112",
      ],
      cta: { label: "Open in EquiSight en vul direct in", href: "/#waitlist" },
    },
    pricing: {
      tiers: [
        { name: "Noodnummers", price: "Gratis", note: "Altijd gratis · voor iedereen, in elk abonnement", highlight: true },
      ],
    },
    finalCTA: {
      eyebrow: "Zorg dat je voorbereid bent",
      title: "Voordat het nodig is.",
      href: "/#waitlist",
    },
    microcopy: [
      "Geen verplichtingen",
      "Binnen 2 minuten ingesteld",
      "Altijd aanpasbaar",
    ],
  },
};
